import React from 'react'
import Header from '../components/header/Header'
import CardList from '../components/cardList/CardList'
import Footer from '../components/footer/Footer'
import "../index.css"






function HomePage() {
  return (
    <>
    
      <Header />
      <CardList />
      <Footer />

    </>
  )
}

export default HomePage